import React from 'react';
import styled from 'styled-components';
const Container = styled.div `
  width: 100%;
  border-bottom: ${({ theme, hasBoldBorder }) => hasBoldBorder ? `2px solid ${theme.secondaryGreyDark}` : `1px solid ${theme.greyDarkMedium}`};
`;
const Content = styled.div `
  width: 100%;
  max-height: ${({ isPanelOpen }) => (isPanelOpen ? '9999px' : 0)};
  overflow: hidden;
  transition: ${({ isPanelOpen }) => isPanelOpen ? 'max-height 1000ms ease-in-out' : 'max-height 500ms cubic-bezier(0, 1, 0, 1)'};
`;
// note that renderToggleButtonAs is a function to render the toggleHeader of the Accordion
// it can pass isOpen and onToggle as part of the injected object that will be be used in the renderToggleButtonAs method
export const AccordionPanel = ({ isOpen, onToggle, renderToggleButtonAs, renderToggleFooterAs, hasBoldBorder, children, }) => {
    return (
    // className is used for styling from parent container
    React.createElement(Container, { hasBoldBorder: hasBoldBorder, className: "panel-container" },
        renderToggleButtonAs && renderToggleButtonAs({ isOpen: !!isOpen, onToggle }),
        React.createElement(Content, { isPanelOpen: isOpen }, children),
        renderToggleFooterAs && renderToggleFooterAs({ isOpen: !!isOpen, onToggle })));
};
